import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const AutorizarInformeConservacion = async (values) => {
    try {

        const resultado = await instance.Backend.post("/Autorizacion/AutorizarInformeConservacion",values, customConfig);
        
        return resultado
        
    } catch (error) {

        console.log(error);
    }
}
export { AutorizarInformeConservacion };